//---------------------------------------------------
//  Nom du fichier : pageProfil.js 
//
//  Description: Component qui affiche la page profil
//               Contient les publications publié, enregstré, réussi
//               Contient la logique pour modifier le profil
//               Contient la logique pour signaler, s'abonner
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import { useState, useEffect } from "react";
import './pageProfil.css';
import './btn.css';
import './color.css';
import { path_dict, sections, translate_grade } from './grades';
import Signalement from "./Signalement";
import GradeSelector from "./gradeSelector";
import ImageCropper from './ImageCropper';
import Background  from "./background.js";
import {callAPI} from './callAPI.js'
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from '@mui/material/Button';

function Section({ icon, title, setFunction, setVariable, actualTitle}) {
  const color = {
    color: setVariable ? 'var(--secondaryLight)' : 'var(--secondary)',
    fontVariationSettings: `'FILL' ${setVariable ? 1 : 0}`,
    transition: "font-variation-settings 0.3s ease, color 0.3s ease"
  };
  const visible = {
    opacity: setVariable ? "100%" : "0%",
  };
  return (
    <div className='label' onClick={() => { setFunction(title) }}>
      <div className="selection" style={visible}></div>
      <div className='jointti'>
        <span className='iconSection material-symbols-outlined' style={color}>{icon}</span>
        <div className="title" style={color}>{actualTitle}</div>
      </div>
    </div>
  );
}

export function Publication({grade, title, imageUrl, id, setPublication, className = null, gradeType}) {
  const [hovered, setHovered] = useState(false);


  let gradeColor = ""
  sections.forEach((section, index) => {
      if(section.includes(grade)){
        gradeColor = path_dict[index]
      }
  });

  const color = {
    backgroundColor: `var(--grade${gradeColor})`
  };

  const image = {
    backgroundImage: `url('https://rockstoclimb.com/uploads/publications/${imageUrl}')`
  }

  const hover = {
    transition: 'all 0.3s ease', 
    boxShadow: hovered 
      ?  `0 0 0.7vw var(--grade${gradeColor}), 0 0 0.7vw var(--grade${gradeColor}) `
      : "None",  
  }

  const postClass = className == null ? "mainPost" : "mainPost postSaved"
  

  return (
    <div className={postClass} style={hover} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={() => {setPublication(id)}}>
      <div className='imagePost' style={image}>
        <div className="fadeBlack"></div>
        <h2 className='titrePost'>{title}</h2>
        <div className='pastille' style={color}><p className="gradePub">{translate_grade(gradeType, grade)}</p></div>
      </div> 
    </div>
  );
}

function callAPIForPublications(userId, typeDeDonner, funcSet){
  const form = new FormData()
  form.append('type', typeDeDonner)
  form.append('user_id', userId)

  callAPI("read", form)
  .then((data) => {
    funcSet(data["result"]); 
  })
  .catch((error) => {
      console.error("API call failed:", error);
  });
}

function SectionPublication({donne, set_Publication, gradeType}) {
  return (
    <div className='gridPublication'>
      {donne.map((num) => (
        <Publication grade={num.grade} title={num.title} imageUrl={num.file_path} id={num.post_id} setPublication={set_Publication} key={num.post_id} gradeType={gradeType}/>
      ))}
    </div>
  );
}

function Follows({data, setShowFollows, name}){
  const { t } = useTranslation();
  const navigate = useNavigate();

  return(
    <>
       <div className="follows_container">
        <div className="quit_btn_follows">
          <span className="material-symbols-outlined openBtn" id="quit_reverse" onClick={() => {setShowFollows(false)}}>close</span>
        </div>
        <div className="all_follows">
          <div className="separator">
              {name == 'followers'? t('followers') : t('following')}
          </div>
          {data.map((user) => (
            <div key={user.id} className="one_follow" onClick={() => {navigate('/profil/' + user.id); setShowFollows(false)}}>
              <div className="one_follow_image" style={{backgroundImage: user.file_path ? "url('https://rockstoclimb.com/uploads/profiles/" + user.file_path + "')" : 'url("/Images/defImage.png")'}}></div>
              <div className="one_follow_name">{user.username}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}


function ModifyProfil({old_bio, old_grade, grade_type, open_modify, profil_id, setType, image, triggerRefresh, setImagePath}){
  const { t } = useTranslation();
  const [bio, setBio] = useState(old_bio)
  const [grade, setGrade] = useState(old_grade);
  const [gradeType , setGradeType] = useState(grade_type)

  //cropp
  const [cropped, setCropped] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [croppedImage, setCroppedImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        setImageSrc(URL.createObjectURL(file)); // Crée un aperçu temporaire
        setCropped(false); // Réinitialise l'état du crop
    }
  };

  const handleCropComplete = (croppedBlob) => {
    setCroppedImage(croppedBlob);
    setCropped(true);
  };

  const imagePhoto = {
    backgroundImage: croppedImage ? `url(${URL.createObjectURL(croppedImage)})` : image
  };

  function modify(){

    let newGrade = translate_grade(gradeType, grade)

    const form = new FormData()
    form.append('type', 'modify')
    form.append('profil_id', profil_id)
    form.append('bio', bio)
    form.append('grade', newGrade)
    form.append('gradeType', gradeType)
    if(croppedImage != null)
      form.append('file', croppedImage, 'cropped.jpg')

    callAPI("write", form)
    .then((data) => {
      open_modify(false)
      setGradeType(gradeType)
      if(croppedImage)
        setImagePath(data.status)
      setType(gradeType)
      triggerRefresh(); // Déclenche le rafraîchissement du composant parent
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }
  return(
    <Background func={() => {open_modify(false)}}>
      <div className="ModifyContainer">
        <div className="modifyChamp">
          <p style={{marginTop: '0.5vw'}} className="bioTitleModfiy">{t('bio')}</p> <textarea className="bioTextArea" value={bio} maxLength={255} onChange={e => setBio(e.target.value)}></textarea>
          <p className="bioTitleModfiy">{t('create_publication_grade')}</p> <GradeSelector gradetype={gradeType} setSelected={setGrade} startWith={grade}></GradeSelector>
          <p className="bioTitleModfiy">{t('profile_grade_type')}</p> 
          <select
                className="selectGradeType"
                name="gradeType" 
                value={gradeType}
                onChange={e => setGradeType(e.target.value)}>
            <option>american</option>
            <option>european</option>
          </select>
          <p className="bioTitleModfiy">{t('profile_image_change')}</p> 
          <div className='imageProfil' style={imagePhoto}>
              <input 
                  required 
                  type='file'
                  name="image" 
                  accept="image/*"
                  className="imageModify"
                  onChange={handleFileChange}/>
          </div>
        </div>
        <div className="buttonsModifys">
          <Button variant="outlined" className="btnModify btBase" onClick={() =>{modify()}}>{t('modif')}</Button>
          <Button variant="outlined" id="cancelModify" className="btnModify btBase" onClick={() =>{open_modify(false)}}>{t('cancel')}</Button>
        </div>
        {!cropped && imageSrc && <ImageCropper imageSrc={imageSrc} onCropComplete={handleCropComplete} />}
      </div>
    </Background>
  )
}

function Profil({ set_grade_type, logged_in, setPublication, publication, setImagePath}) {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('Publication');
  const [signaling, setSignaling] = useState(false)
  const [modify, setModify] = useState(false)
  const [OwnPublications, setOwnPublications] = useState([]);
  const [savePublications, setSavePublications] = useState([]);
  const [completedPublications, setCompletedPublications] = useState([]);

  const [name, setName] = useState("")
  const [bio, setBio] = useState("")
  const [grade, setGrade] = useState("")
  const [profilId, setProfilId] = useState("")
  const [gradeType, setGradeType] = useState("")
  const [isMyProfil, setIsMyProfil] = useState(false)
  const [refresh, setRefresh] = useState(false);
  const [image, setImage] = useState(false);
  const [following, setFollowing] = useState(false)
  const [nbAbonne, setNbAbonne] = useState(false)
  const [nbAbonnement, setNbAbonnement] = useState(false)

  const [followers, setFollowers] = useState(false)
  const [followings, setFollowings] = useState(false)
  const [showFollows, setShowFollows] = useState(false)


  const [isLoading, setIsLoading] = useState(false)
  
  const navigate = useNavigate();
  let { user_id, from } = useParams();
  useEffect(() => {
    const form = new FormData()
    form.append('type', 'getUserProfile')
    form.append('user_id', user_id)

    callAPI("read", form)
    .then((data) => {
      setGrade(data.result.grade == 'null' ? t('grade_empty'):data.result.grade)
      setBio(data.result.bio == 'null' ? t('bio_empty'):data.result.bio)
      setProfilId(data.result.id)
      setName(data.result.username)
      setGradeType(data.grade_type)
      setIsMyProfil(data.user_id == data.result.user_id)
      setImage( (data.result.file_path != null ? ("url('https://rockstoclimb.com/uploads/profiles/" + data.result.file_path + "')") : 'url("/Images/defImage.png")' ) )
      setFollowing(data.result.isFollowing)
      setNbAbonne(data.result.nbAbonne)
      setNbAbonnement(data.result.nbAbonnement)
      setFollowers(data.result.followers)
      setFollowings(data.result.followings)

    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }, [refresh, user_id]);
  

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const subscribe = () => {

    let was_following = following
    if(isLoading) return
    setIsLoading(true)

    setNbAbonne(following ? nbAbonne - 1 : nbAbonne + 1)

    const form = new FormData()
    form.append('type', 'subscribe')
    form.append('other_user_id', user_id)
    form.append('value', !following)
    setFollowing(!following)
    callAPI("write", form)
    .then((data) => {
      setIsLoading(false)
      if(was_following) 
        setFollowers(prevFollowers => prevFollowers.filter(user => user.id != data.user_id))
      else
        setFollowers(prevFollowers => [...prevFollowers, {id:data.user_id, username:data.username, file_path:data.imagePath}]);
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  useEffect(() => {
    callAPIForPublications(user_id, 'getUserPost', setOwnPublications)
    callAPIForPublications(user_id, 'getUserPostSaved', setSavePublications)
    callAPIForPublications(user_id, 'getUserPostAchieved', setCompletedPublications)
  }, [publication, refresh, user_id]);

  const follow = following ? "person_remove" : "person_add"

  const scroll = {
    overflow: modify ? 'hidden' : undefined
  }

  return (
    <div style={scroll} className='pageProfil'>
      <div className='header'>
        <div className='info'>
          <div className="nameAndPicture">
            <div className="photo_container">
              <div style={{backgroundImage:image}} className='photo'></div>
            </div>
            <h1 className='username'>{name}</h1>
            <div className="ButtonsInteractionsProfil">
              {!isMyProfil && logged_in && <span className="material-symbols-outlined btnProfil" onClick={() => setSignaling(!signaling)} style={{ cursor: 'pointer' }} title={t('report')}>report</span>}
              {!isMyProfil && logged_in && <span className="material-symbols-outlined btnProfil" onClick={() => subscribe()} style={{cursor: 'pointer' }} title={following ? t('profile_unfollow') : t('profile_follow') }>{follow}</span>}
              {!isMyProfil && logged_in && <span className="material-symbols-outlined btnProfil" onClick={() => navigate(`/chat/${user_id}`)} style={{ cursor: 'pointer' }} title={t('profile_send')}>send</span>}
              {isMyProfil && <span id="edit" className="material-symbols-outlined" onClick={() => {setModify(!modify)}}style={{ cursor: 'pointer' }} title={t('profile_modify')}> edit </span>}
            </div>
          </div>
          <h2 className='abo'>{OwnPublications.length} {t('post')} <span className="follow_click" onClick={() => {setShowFollows(showFollows ? false : 'followings')}}>{nbAbonnement} {t('following')}</span> <span className="follow_click" onClick={() => {setShowFollows(showFollows ? false :'followers')}}>{nbAbonne} {t('followers')}</span> </h2>
          <p className='bio'>{bio}</p>

          <p className='grade bio'>
          {translate_grade(gradeType, grade)}
          </p>
        </div>
        <span id="quit" className="material-symbols-outlined" onClick={() => {navigate(from == null ? '/' : (from == 'admin' ? "/admin" : from == 'rencontre' ? "/rencontre/" + user_id : '/chat/' + from))}}>close</span>
      </div>
      {signaling && <Signalement from="profil" open_signalement={setSignaling} id={user_id} idChange={'customSignal'}/>}
      {modify && <ModifyProfil 
                      profil_id={profilId} 
                      old_bio={bio} 
                      old_grade={grade} 
                      grade_type={gradeType} 
                      open_modify={setModify} 
                      setType={set_grade_type}
                      setImagePath={setImagePath}
                      image={image}
                      triggerRefresh={() => setRefresh(prev => !prev)} // Ajout ici
                      />}

      <div className='menuHeader'>
        <div className='ligne'></div>
        <Section
          icon={"verified"}
          title="Réussite"
          setFunction={handleSectionChange}
          actualTitle={t('profile_achieved')}
          setVariable={activeSection === 'Réussite'}
        />
        <Section
          icon="bookmarks"
          title="Enregistrées"
          setFunction={handleSectionChange}
          actualTitle={t('profile_saved')}
          setVariable={activeSection === 'Enregistrées'}
        />
        <Section
          icon="grid_view"
          title="Publication"
          setFunction={handleSectionChange}
          actualTitle={t('post')}
          setVariable={activeSection === 'Publication'}
        />
      </div>
      {showFollows && 
      <Background func={() => {setShowFollows(false)}}>
        <Follows setShowFollows={setShowFollows} data={showFollows == 'followers' ? followers : followings} name={showFollows == 'followers' ? "followers" : "followings"}></Follows>
      </Background> }
      {activeSection == 'Publication' && <SectionPublication donne={OwnPublications} set_Publication={setPublication} gradeType={gradeType}/>}
      {activeSection == 'Enregistrées' && <SectionPublication donne={savePublications} set_Publication={setPublication} gradeType={gradeType}/>}
      {activeSection == 'Réussite' && <SectionPublication donne={completedPublications} set_Publication={setPublication} gradeType={gradeType}/>}
    </div>
  );
}

export default Profil;
